/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#000000";
export const ColorTextSecondary = "#000000";
export const ColorBackgroundPrimary = "#FFFFFF";
export const ColorIconPrimary = "#000000";
export const ColorIconSecondary = "#000000";
